import AccountMyAccount from './MyAccount'
import AccountActivityLog from './ActivityLog'

const Modules = {
    AccountMyAccount,
    AccountActivityLog,
}

export default Modules
